import AsyncLoader from 'component/AsyncLoader';

export const PaymentPassword =  AsyncLoader(() => import('./PaymentPassword'));
export const TechnologyDock =  AsyncLoader(() => import('./TechnologyDock'));